import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { TadaSvgImage } from "../../lib/icons";
import { getCommunityName, getUserMonthlyIncome, getWantsToSpeakWithExpert } from "../../store";
import { Answer } from "./Answer";
import { goToModule } from "../../actions";
import { Show, formatCurrency } from "../../lib/utils";
import { getStartingCost } from "../PricingModule/selectors";

const FinancialResults = ({ action }) => {
  const [spinning, setSpinning] = useState(true);
  const dispatch = useDispatch();
  const communityName = useSelector(getCommunityName);
  const wantsToSpeakWithExpert = useSelector(getWantsToSpeakWithExpert);
  const income = useSelector(getUserMonthlyIncome);
  const startingCost = useSelector(getStartingCost);

  useEffect(() => {
    setTimeout(() => {
      setSpinning(false);
    }, 5000);
  }, []);

  const goFurther = () => {
    dispatch(goToModule(action));
  };

  let shortfall = 2500;

  if (startingCost && income && income < startingCost) {
    shortfall = startingCost - income;
  }

  return (
    <>
      <Show when={spinning}>
        <Header>
          <div className="h1">Calculating results</div>
          <Spinner />
        </Header>
      </Show>

      <Show when={!spinning}>
        <Header>
          <TadaSvgImage />
          <div className="h1">Great News</div>
          <div className="h2">Based on your answers you are ready for {communityName}</div>
        </Header>

        <Show when={wantsToSpeakWithExpert}>
          <p style={{ color: "#595d61", textAlign: "center", fontSize: "14px" }}>
            A community expert will be in touch shortly
          </p>
        </Show>

        <ShadowCard>
          <div className="h3">Financial Assessment Recommendations</div>

          <div className="h4" onClick={goFurther}>
            Sell you home with a Senior-Focused Realtor
          </div>

          <p>
            During the transition to senior living there are lots of moving parts. It is important to understand all of
            your options when it comes to selling your home and downsizing. Senior focused agents will be able to assist
            you with everything from packing, moving and estate sales to listing and selling the home.
          </p>

          <Answer onClick={goFurther}>Speak To Senior Realtor</Answer>

          <div className="h4" onClick={goFurther}>
            Have you considered a Bridge Loan?
          </div>

          <p>
            Based on your current monthly income and future expenses of senior living it appears you could have a
            monthly shortfall of <b>{formatCurrency(shortfall)}</b> until your home sells. A bridge loan is a popular
            way to receive money now to pay for care while you wait on other funds to come in later.
          </p>

          <Answer onClick={goFurther}>Speak With Financial Concierge</Answer>
        </ShadowCard>
      </Show>
    </>
  );
};

const Header = styled.div`
  text-align: center;
  margin-bottom: 18px;

  svg {
    margin-bottom: 18px;
  }

  .h1 {
    color: #14222d;
    text-align: center;
    font-size: 22px;
    line-height: 30px;
  }

  .h2 {
    color: #595d61;
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    max-width: 280px;
    margin: 0 auto;
  }
`;

const ShadowCard = styled.div`
  box-shadow: 0 2px 9px rgba(217, 217, 217, 0.5);
  border-radius: 11px;
  margin-bottom: 10px;
  padding: 17px;

  .h3 {
    color: #312f4c;
    font-weight: 800;
    font-size: 21px;
    line-height: 121.6%;
    margin-bottom: 1em;
  }

  .h4 {
    color: #141233;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 1em;
  }

  p {
    font-size: 12px;
    line-height: 18px;
  }

  ${Answer}:not (.last-message) {
    margin-top: 0;
  }
`;

const Spinner = styled.div`
  width: 300px;
  height: 300px;
  margin: 0 auto;
  background: url("https://flevix.com/wp-content/uploads/2019/07/Comp-2.gif") no-repeat center;
`;

export default FinancialResults;
